import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import * as React from "react";
import * as ReactDOM from "react-dom";
/* global document, Office, module, require */

initializeIcons();

const render = () => {
  ReactDOM.render(
    <AppContainer>
      <div>
        <h2>Welcome to the Correspondence App</h2>
        <p>The Correspondence App is up and running.</p>
      </div>
    </AppContainer>,
    document.getElementById("container"),
  );
};

/* Render homepage */
render();